import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AppState } from '../app.service';
import { CordovaService } from '../cordova.service';
import { RoutineInfo } from './routine-info.model';
import { RoutineLevel } from './routine-level.model';
import { HomeUiService } from '../new-design/home-ui.service';
import { animate, query, stagger, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'meet-cue',
  templateUrl: './meet-cue.component.html',
  styleUrls: ['./meet-cue.component.scss'],
  animations: [
    trigger('animateContent', [
      transition(':enter', [
        query(':scope > *', [
          style({ opacity: 0, transform: 'translateY(8px)' })
        ], { optional: true }),

        query(':scope > *', [
          stagger(100, [
            animate(
              '800ms cubic-bezier(0.76, 0, 0.24, 1)',
              style({ opacity: 1, transform: 'translateY(0)' })
            )
          ])
        ], { optional: true })
      ]),

      transition(':leave', [
        animate(
          '0.3s cubic-bezier(0.76, 0, 0.24, 1)',
          style({ opacity: 0, transform: 'translateY(-75px)' })
        )
      ])
    ])
  ]
})
export class MeetCueComponent implements OnInit {

    @Input() inverted : boolean = false
    @Input() levels : RoutineLevel
    @Input() progressItems = [];
    @Input() currentIndex = 0;
    @Input() screenId: any;
    changeCue: boolean = false

  constructor(private cordovaService: CordovaService,
    public homeUIService: HomeUiService,
     private appState: AppState) { 
    this.changeCue = this.appState.get('changeCue')
  }

  ngOnInit() {
  }

}
